import "./bootstrap";
import "./sentry";
import sort from "@alpinejs/sort";

document.addEventListener("livewire:init", () => window.Alpine.plugin(sort));
